/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dynamic_Ui_SubmitInputs */

const en_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

const ar_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال`)
};

const bn_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাবমিট করুন`)
};

const de_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

const es_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const fr_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre`)
};

const pt_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const zh_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交`)
};

const tr_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönder`)
};

const ru_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить`)
};

const pl_dynamic_ui_submit = /** @type {(inputs: Dynamic_Ui_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prześlij`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Dynamic_Ui_SubmitInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dynamic_ui_submit = /** @type {((inputs?: Dynamic_Ui_SubmitInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dynamic_Ui_SubmitInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dynamic_ui_submit(inputs)
	if (locale === "bn") return bn_dynamic_ui_submit(inputs)
	if (locale === "de") return de_dynamic_ui_submit(inputs)
	if (locale === "es") return es_dynamic_ui_submit(inputs)
	if (locale === "fr") return fr_dynamic_ui_submit(inputs)
	if (locale === "pt") return pt_dynamic_ui_submit(inputs)
	if (locale === "zh") return zh_dynamic_ui_submit(inputs)
	if (locale === "tr") return tr_dynamic_ui_submit(inputs)
	if (locale === "ru") return ru_dynamic_ui_submit(inputs)
	if (locale === "pl") return pl_dynamic_ui_submit(inputs)
	return en_dynamic_ui_submit(inputs)
});